import React from 'react'

export default function Footer() {
  return (
    <footer>
      <div className="Footer-Container">
        <h6>Made by Chris Lilley</h6>
        <ul className="Footer-Links">
          <li><a href="https://github.com/ChrisLilleyDev" target="_blank" rel="noopener noreferrer">Github</a></li>
          <li><a href="https://www.linkedin.com/in/chris-lilley-dev/" target="_blank" rel="noopener noreferrer">Linkedin</a></li>
          <li><a href="mailto:chris.lilley.dev@gmail.com">Email</a></li>
        </ul>
      </div>
    </footer>
  )
}
